import UpdateShopBasketItemRequestModel from '../../generated/types/model/resource/UpdateShopBasketItemRequestModel';

export default class UpdateShopBasketItemRequestViewModel extends UpdateShopBasketItemRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
